import React, { useState, useRef, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import updown from "../../Assets/Images/CommanImages/updown.png";
import Filter from "../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import leftArrow from "../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../Assets/Images/CommanImages/Rarrowbar.png";
import SelectedValuesDropdown from "../Shared/SelectedValuesDropdown/SelectDropdown";
import "katex/dist/katex.min.css";
import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";
import FlagIcon from "../../Assets/Images/CommanImages/flag_icon.png";
import EyeLockIcon from "../../Assets/Images/CommanImages/eye-lock-icon.png";

const TablewithCheckbox = ({
  headers = [],
  data = [],
  searchPlaceholder = "Search...",
  selectedRows,
  setSelectedRows,
  renderQuestionText,
  renderQuestionTextModel,
  expandedStates,
  toggleImage,
  questionDetailsMap,
  handleEyeClick,
  pageType = "default",
  onRowLinkClick,
  filterConfig = {},
}) => {
  const navigate = useNavigate();
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const [filters, setFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [isFilterDropdownSelected, setIsFilterDropdownSelected] =
    useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [isQuesModalVisible, setIsQuesModalVisible] = useState(false);
  const [changeStatus, setChangeStatus] = useState(false);
  const columnDropdownRef = useRef(null);
  const flagCountIndex = headers.indexOf("Flag Count");
  const statusTextIndex = headers.indexOf("Status");

  // useEffect(() => {
  //   if (headers.length > 0) {
  //     const initial = headers
  //       .filter((header) => header !== "Status" && header !== "Set ID")
  //       .slice(0, 5);
  //     setVisibleColumns([
  //       headers[0],
  //       ...initial.filter((h) => h !== headers[0]),
  //     ]);
  //   }
  // }, [headers]);

  useEffect(() => {
    if (headers.length > 0) {
      const initial = headers
        .filter((header) => header !== "Status" && header !== "Set ID")
        .slice(0, 5);
      setVisibleColumns([
        "Question ID", // force include
        ...initial.filter((h) => h !== "Question ID"),
      ]);
    }
  }, [headers]);

  // const handleColumnSelection = (column) => {
  //   if (visibleColumns.includes(column)) {
  //     setVisibleColumns(visibleColumns.filter((col) => col !== column));
  //   } else {
  //     setVisibleColumns([...visibleColumns, column]);
  //   }
  // };

  const handleColumnSelection = (column) => {
    if (column === "Question ID") return; // prevent removal

    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters });
      setCurrentPage(1);
      setIsFiltersApplied(true);
      setIsFilterVisible(false);
    }
  };

  const handleResetFilter = () => {
    setFilters({});
    setAppliedFilters({});
    setAverageRunTime("");
    setIsFiltersApplied(false);
  };

  const handleFilterSelection = (selectedOption, header) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [header]: selectedOption,
    }));
    setIsFilterDropdownSelected(true);
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;
    const matchesFilters = Object.entries(appliedFilters).every(
      ([key, value]) => {
        const colIndex = headers.indexOf(key);
        return value ? row[colIndex] === value : true;
      }
    );
    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sortedData = useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  const isAllSelected = paginatedData.every((row) =>
    selectedRows.includes(row[0])
  );
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const currentPageQuestionIds = paginatedData.map((row) => row[0]);
      setSelectedRows((prev) => {
        const unique = new Set([...prev, ...currentPageQuestionIds]);
        return Array.from(unique);
      });
    } else {
      const currentPageQuestionIds = new Set(
        paginatedData.map((row) => row[0])
      );
      setSelectedRows((prev) =>
        prev.filter((id) => !currentPageQuestionIds.has(id))
      );
    }
  };

  const handleRowSelect = (rowIndex) => {
    const questionId = paginatedData[rowIndex][0];
    setSelectedRows((prev) => {
      if (prev.includes(questionId)) {
        return prev.filter((id) => id !== questionId);
      } else {
        return [...prev, questionId];
      }
    });
  };

  const [columnWidth, setColumnWidth] = useState(400);
  const columnRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (isResizing.current) {
      const newWidth = Math.max(
        100,
        event.clientX - columnRef.current.offsetLeft
      );
      setColumnWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const toggleChangeStatusVisibility = () => {
    setChangeStatus((prevState) => !prevState);
  };

  return (
    <div>
      {/* Search and controls */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "82vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
              width: "490px",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      {/* Top Row: Filter and Column Selection */}
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {/* {headers
                  .filter(
                    (_, index) =>
                      (index === 0 || index > 4 || (index >= 2 && index < 4)) &&
                      index !== 7
                  )
                  .map((column, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleColumnSelection(column);
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`column-${index}`}
                        name="columnSelection"
                        value={column}
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        readOnly
                      />
                      <label htmlFor={`column-${index}`}>{column}</label>
                    </div>
                  ))} */}
                {headers
                  .filter(
                    (_, index) =>
                      (index === 0 || index > 4 || (index >= 2 && index < 4)) &&
                      index !== 7
                  )
                  .map((column, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        if (column === "Question ID") return; // Do not allow toggle
                        e.stopPropagation();
                        handleColumnSelection(column);
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`column-${index}`}
                        name="columnSelection"
                        value={column}
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        readOnly
                        disabled={column === "Question ID"} // disable if Question ID
                      />
                      <label htmlFor={`column-${index}`}>{column}</label>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className={`Heading-tc resizable-header ${
                        index === 1 ? "resizable-header" : ""
                      }`}
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                        }}
                      >
                        {index === 0 && (
                          <input
                            type="checkbox"
                            className="delete-question-checkbox-dqc"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "105px",
                            }}
                          />
                        )}
                        {heading}
                        {index === 1 && (
                          <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                          ></div>
                        )}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                  >
                    {visibleColumns.map((column, cellIndex) => (
                      <td
                        key={cellIndex}
                        style={{
                          width: cellIndex === 1 ? `${columnWidth}px` : "auto",

                          textAlign: "left",
                          color: "#6A6A6A",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: `${columnWidth}px`,
                          width: "200px",
                        }}
                      >
                        {cellIndex === 0 ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="checkbox"
                              className="delete-question-checkbox-dqc"
                              checked={selectedRows.includes(row[0])}
                              onChange={() => handleRowSelect(rowIndex)}
                            />
                            <div
                              style={{
                                width: "100px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div className="flag-container-ques-bank-dash">
                                {row[7] > 0 && (
                                  <div className="flag-count-ques-bank-dash">
                                    <span>{row[7] > 99 ? "99" : row[7]}</span>
                                  </div>
                                )}
                                {row[7] > 0 && (
                                  <img
                                    src={FlagIcon}
                                    alt="flag count"
                                    style={{ width: "24px" }}
                                  />
                                )}
                              </div>
                              <span
                                style={{
                                  width: "20px",
                                  textAlign: "center",
                                  marginRight: "40px",
                                }}
                              >
                                {row[4] === "Marked special" && (
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEyeClick(row[0])}
                                  >
                                    <img
                                      src={EyeLockIcon}
                                      alt="eyeicon"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </span>
                                )}
                              </span>
                            </div>
                            <Link
                              style={{ color: "#337ab7" }}
                              onClick={(e) => {
                                e.preventDefault();
                                const questionId = row[0];
                                setSelectedQuestion(
                                  questionDetailsMap[questionId]
                                );
                                setIsQuesModalVisible(true);
                              }}
                            >
                              <span
                                className="truncated-text"
                                title={row[headers.indexOf(column)]}
                              >
                                {headers.indexOf(column) === 2
                                  ? renderQuestionText(
                                      row[headers.indexOf(column)]
                                    )
                                  : row[headers.indexOf(column)]}
                              </span>
                            </Link>
                          </div>
                        ) : (
                          <span className="truncated-text-2">
                            {headers.indexOf(column) === 2
                              ? renderQuestionText(row[headers.indexOf(column)])
                              : row[headers.indexOf(column)]}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              <img src={leftArrow} alt="" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {"<"}
            </button>
            {renderPagination()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {">"}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              <img src={rightArrow} alt="" />
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn-HOD"
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              <p>X</p>
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              <button
                className="create-test-section-btn"
                onClick={handleApplyFilter}
              >
                APPLY
              </button>
              {isFiltersApplied && (
                <button
                  className="create-test-section-btn"
                  onClick={handleResetFilter}
                >
                  RESET
                </button>
              )}
            </div>
            <div
              className="filter-options-container"
              style={{
                maxHeight: "550px",
                overflowY: "auto",
                paddingRight: "10px",
              }}
            >
              {headers
                .filter(
                  (_, index) => index === 0 || (index >= 3 && index !== 4)
                )
                .map((header, filteredIndex) => {
                  const originalIndex =
                    filteredIndex === 0
                      ? 0
                      : filteredIndex + 2 + (filteredIndex >= 2 ? 1 : 0);

                  let uniqueOptions = [
                    ...new Set(
                      data
                        .map((row) => row[originalIndex])
                        .filter((option) => option)
                    ),
                  ];

                  if (originalIndex === 0 || originalIndex === 6) {
                    uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  }

                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [header]: selectedOption,
                        }));
                      }}
                      options={uniqueOptions.map((value) => ({
                        label: value,
                        id: value,
                      }))}
                      selected={filters[header] || ""}
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
      {isQuesModalVisible && selectedQuestion && (
        <div
          className="modal-overlay"
          onClick={() => setIsQuesModalVisible(false)}
        >
          <div className="modal-content-all-question">
            <button
              className="modal-close-button"
              onClick={() => setIsQuesModalVisible(false)}
            >
              X
            </button>
            <div className="modal-header-del">
              <p
                style={{
                  fontSize: "18px",
                  backgroundColor: "#D6D6D6",
                  padding: "8px",
                }}
              >
                QUESTION ID # {selectedQuestion.questionId}
              </p>
            </div>
            <div
              className="modal-question-options"
              style={{
                maxHeight: "600px",
                overflowY: "auto",
                boxSizing: "border-box",
              }}
            >
              <p style={{ fontSize: "18px" }}>
                Question Type: {selectedQuestion.questionType}
              </p>
              {selectedQuestion.options.length > 0 ? (
                <ul>
                  <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Question:
                  </span>
                  <span style={{ fontSize: "25px", marginLeft: "3px" }}>
                    {renderQuestionTextModel(selectedQuestion.questionText)}
                  </span>
                  {selectedQuestion.options.map((option, index) => (
                    <li key={index} className="option-list-item">
                      <div className="toggle-radio">
                        <input
                          type="radio"
                          checked={option.option_correct_flag}
                          readOnly
                        />
                        <div>{renderQuestionTextModel(option.option_text)}</div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No options available for this question.</p>
              )}
              {selectedQuestion.tags.length > 0 && (
                <p
                  style={{
                    marginTop: "20px",
                    fontSize: "18px",
                    color: "#6A6A6A",
                  }}
                >
                  {selectedQuestion.tags
                    .map((tag) => {
                      if (tag.tag_type === 1) {
                        return tag.tag_value;
                      } else if (tag.tag_type === 2 && tag.tag_value != null) {
                        return tag.tag_name;
                      }
                      return null;
                    })
                    .filter(Boolean)
                    .join(", ")}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TablewithCheckbox;
